import React, { useRef, useState } from "react";
import { withFeatureSafe } from 'Common/ErrorBoundaries';
import PropTypes from "prop-types";
import validateEmail from "Utils/ValidateEmail";
import CrossIcon from "SVGS/CrossIcon";

const MultiEmailInput = ({
  emails,
  setEmails,
  placeholder = "",
  onEmailAdd,
  onEmailRemove,
  setMyValidationModel,
}) => {
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef(null);
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    setMyValidationModel({ errorEmailTo: "" });
  };

  const handleKeyDown = (e) => {
    if (["Enter", ",", " "].includes(e.key)) {
      e.preventDefault();
      addEmail(inputValue.trim());
    }
  };
  if (emails[0]?.includes(",")) {
    const value = emails.toString().split(",");
    let parsedEmails = [];
    for (const email of value) {
      parsedEmails.push(email.trim());
    }
    setEmails(parsedEmails);
  }

  const addEmail = (email) => {
    const validation = validateEmail(email);
    if (email && validation.isValid) {
      if (!emails.includes(email)) {
        const updatedEmails = [...emails, email];
        setEmails(updatedEmails);
        if (onEmailAdd) onEmailAdd(email);
        setInputValue("");
      } else {
        setMyValidationModel({ errorEmailTo: "This email is already added." });
      }
    } else if (email) {
      setMyValidationModel({ errorEmailTo: validation.message });
    }
  };

  const removeEmail = (index) => {
    const emailToRemove = emails[index];
    const updatedEmails = emails.filter((_, i) => i !== index);
    setEmails(updatedEmails);
    if (onEmailRemove) onEmailRemove(emailToRemove);
  };

  const handleParentClick = () => {
    inputRef.current.focus();
  };

  const handleFocus = (event) => {
    const innerDiv = event.currentTarget.querySelector(".Multi-Email-Input");
    if (innerDiv) {
      innerDiv.style.border = "1px solid #E85B46";
    }
  };

  const handleBlur = (event) => {
    const innerDiv = event.currentTarget.querySelector(".Multi-Email-Input");
    if (innerDiv) {
      innerDiv.style.border = "1px solid #E5E7EB";
    }
    addEmail(inputValue.trim());
  };

  return (
    <div onFocus={handleFocus} onBlur={handleBlur} onClick={handleParentClick}>
      <div className="px-3 py-1 min-h-[28px] border border-gray-300 rounded-[4px] Multi-Email-Input">
        <div className="flex flex-wrap items-center gap-2">
          {emails
            .filter((v) => v)
            .map((email, index) => (
              <span
                key={index}
                className="flex items-center px-3 py-1 text-gray-700 bg-gray-200 rounded-full"
              >
                <span
                  title={email}
                  className="max-w-[270px] overflow-hidden text-ellipsis whitespace-nowrap"
                >
                  {email}
                </span>
                <button
                  onClick={() => removeEmail(index)}
                  className="ml-2 text-black hover:text-red-700 cursor-pointer"
                  aria-label="Remove email"
                >
                  <CrossIcon size={20} aria-hidden />
                </button>
              </span>
            ))}
          <input
            ref={inputRef}
            value={inputValue}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            placeholder={placeholder}
            className="border-none min-w-[20px] h-full max-w-[350px] focus:outline-none focus:ring-0"
            style={{
              width: `${inputValue.length + 3}ch`,
            }}
          />
        </div>
      </div>
    </div>
  );
};

MultiEmailInput.propTypes = {
  emails: PropTypes.arrayOf(PropTypes.string).isRequired,
  setEmails: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  onEmailAdd: PropTypes.func,
  onEmailRemove: PropTypes.func,
  setMyValidationModel: PropTypes.func.isRequired,
};

export default withFeatureSafe(MultiEmailInput);